import React from 'react'
import './footer.css'

export default function footer() {
  return (
    <footer className='footer'>
        <div className='container'>
            <div></div>
            <div className='footer_panel'> 
                <p>© Copyright 2025, <span>SOFITEL</span>, All Rights Reserved</p>
            </div>
     
    </div>
    </footer>
  )
}
